// GlassCard — content surface (feed posts, list rows, stat cards).
import React from 'react';
import GlassSurface, { GlassSurfaceProps } from './GlassSurface';
import { glassTokens } from './tokens';
import { spacing } from '../../constants/theme';

export interface GlassCardProps extends GlassSurfaceProps {
  padding?: number;
}

export default function GlassCard({
  padding = spacing.lg,
  radius = glassTokens.radius.lg,
  contentStyle,
  ...rest
}: GlassCardProps) {
  return <GlassSurface variant="card" radius={radius} contentStyle={[{ padding }, contentStyle]} {...rest} />;
}
